module.exports = __webpack_public_path__ + "img/u1216.47817382.svg";